//Реакт
import React, { useState } from 'react';
import { ProviderBooking } from './bookingProvider';
import { useBookingContext } from './bookingContext';
//Библиотеки и Api
//компоненты
import StepBuy from './steps/buy/step-buy';
import StepPreview from './steps/preview/step-preview';
import StepAfterpay from './steps/afterpay/step-afterpay';
import BookingHeader from './components/booking-header/booking-header';
import WordScript from './scripts/WordScripts';
//Стили
import './styles.css'

export default function BookingWithProvider({children, className='', apiBookingByCard = null, apiBookingByCertificate = null, apiBookingByBalance = null, ...other}) {
    return (
        <ProviderBooking {...other}>
            {children}
            <div className={`${className}`}>
                <BookingComponent 
                    apiBookingByCard={apiBookingByCard} 
                    apiBookingByCertificate={apiBookingByCertificate} 
                    apiBookingByBalance={apiBookingByBalance}
                />
            </div>
        </ProviderBooking>
    );
}

function BookingComponent({className = '', apiBookingByCard, apiBookingByCertificate, apiBookingByBalance}) {
    const [step, setStep] = useState(1);
    const [_previewData, set_previewData] = useState({})
    const { bookingData , fetchBalances, resetFields} = useBookingContext();

    const { promocode, balanceId, productTime, certificate, timeId, countPeople, productId, selectedDate, user, slotTime, balances} = bookingData;
    const { promocodeString } = promocode;
    const { certificateString, certificateMinutes } = certificate;
    const { name, email, phone, surname } = user

    const nextStep = () => {
        setStep(step + 1);
    };

    const prevStep = () => {
        setStep(step - 1);
    };

    const goToFirst = () => {
        setStep(1)
    };

    const handleBookByBalance = async () => {

        if (!apiBookingByBalance) return false; 

        const fetchBookingByBalance = async () => {
            let apiBookings = apiBookingByBalance.Store({
               name: name, surname: surname, email: email, phone: phone, date: selectedDate, timeId: timeId, certificate: certificateString, 
               minutes: productTime, balanceId: balanceId
            });
        
            const bookingResult = await apiBookings.getResponse({});
            if(bookingResult) {
                setStep(3);
                resetFields();
                fetchBalances();
                return true;
            } else {
                setStep(1);
                resetFields();
                return false;
            }
        };
        return await fetchBookingByBalance();
    }

    const handleBookByCard = async () => {
        if (!apiBookingByCard) return false; // Если API недоступен, возвращаем false
        
        const fetchBookingByCard = async () => {
            let apiBookings = apiBookingByCard.Store({
                name, surname, email, phone, productId, 
                date: selectedDate, timeId, countPeople, promocode: promocodeString
            });
            
            const bookingResult = await apiBookings.getResponse({});
            if (bookingResult) {
                set_previewData({ bookingType: "card", ...bookingResult });
                nextStep();
                return true; // Успешное бронирование
            } 
            return false; // Ошибка бронирования
        };
        
        return await fetchBookingByCard(); // Возвращаем результат
    };
    const handleBookByCertificate = async () => {
        if (!apiBookingByCertificate) return false; // Если API недоступен, возвращаем false
        
        const fetchBookingByCertificate = async () => {
            let apiBookings = apiBookingByCertificate.Store({
                name, surname, email, phone, date: selectedDate, timeId, certificate: certificateString
            });
            
            const bookingResult = await apiBookings.getResponse({});
            if (bookingResult) {
                setStep(3);
                resetFields();
                return true; // Успешное бронирование
            } else {
                setStep(1);
                resetFields();
                return false; // Ошибка бронирования
            }
        };
        
        return await fetchBookingByCertificate(); // Возвращаем результат
    };

    const handlePreviewBalance = () => {
        set_previewData(
            {
                bookingType: "balance",
                slot_time_date: selectedDate, 
                slot_time_start: slotTime?.find((slot) => slot?.timeId == timeId)?.dateStart ?? null,
                products: [
                    {
                        name: productTime + " " + WordScript.declineWord(productTime, [' минута', ' минуты', ' минут']),
                        tarif: "по депозиту " + balances?.find((balance) => balance?.id == balanceId)?.type_name ?? null
                    }
                ]
            }
        );
        nextStep();
    }

    const handlePreviewCertificate = () => {
        set_previewData(
            {
                bookingType: "certificate",
                slot_time_date: selectedDate, 
                slot_time_start: slotTime?.find((slot) => slot?.timeId == timeId)?.dateStart ?? null,
                products: [
                    {
                        name: certificateMinutes + " " + WordScript.declineWord(certificateMinutes, [' минута', ' минуты', ' минут']),
                        tarif: "по сертификату " + certificateString
                    }
                ]
            }
        );
        nextStep();
    }
    const actionPay = async (type) => {
        switch(type) {
            case "balance":
                await handleBookByBalance();
                break;
            case "certificate":
                await handleBookByCertificate();
                break;
            case "card":
                actionPayByCard();
                break;
            default:
                await handleBookByCard();
        }
        set_previewData({});
    }

    const actionPayByCard = async () => {
        let payUrl = _previewData.url_for_pay;
        if (!payUrl) return null;
        //window.open(payUrl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        window.open(payUrl, '_blank');
        nextStep()
    }
    

    const steps = [
        <StepBuy 
            nextStep={nextStep} 
            handleBookByBalance={handlePreviewBalance} 
            handleBookByCard={handleBookByCard} 
            handleBookByCertificate={handlePreviewCertificate}
            hasBookByCard={apiBookingByCard ? true : false}
            hasBookByBalance={apiBookingByBalance ? true : false}
            hasBookByCertificate={apiBookingByCertificate ? true : false}
        />,
        <StepPreview actionPay={actionPay} nextStep={nextStep} prevStep={prevStep} previewData={_previewData}/>,
        <StepAfterpay prevStep={prevStep}  goToFirst={goToFirst}/>
    ];

    return (
        <>
            <div className={`booking__card ${className}`}>
                <div className="booking__card-header">
                    <BookingHeader prevStep={prevStep} step={step}/>
                </div>
                <div className="booking__card-body">
                    {steps[step - 1] || <>Error: Unknown step</>}
                </div>
            </div>
        </>
    );
}
